import graphqlClient from '@/graphql/graphql-client';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import {
  InsertOrgCompanyDocument,
  type InsertOrgCompanyMutationVariables,
} from '@/graphql/generated/graphql';

export const useInsertOrgCompany = () => {
  const queryClient = useQueryClient();
  const mutation = useMutation({
    mutationKey: ['insert-org-company'],
    mutationFn: (variables: InsertOrgCompanyMutationVariables) =>
      graphqlClient.request(InsertOrgCompanyDocument, variables),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['companies'] });
    },
  });

  return {
    ...mutation,
    insertOrgCompany: mutation.mutate,
    insertOrgCompanyAsync: mutation.mutateAsync,
  };
};

export const INSERT_COMPANY_MUTATION = InsertOrgCompanyDocument;
